import { Icon, IconSizeClasses } from '@eppendorf/vnls-react-components';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

export function SubscriptionNeedMoreDevices(): ReactElement {
  const { t } = useTranslation();
  return (
    <div
      className="flex flex__dir--column gap-l border-dashed border-color-blue-500 p-xl p-top-m border-radius-m bg-blue-50 flex__ai--center"
      style={{ borderWidth: '2px' }}
    >
      <Icon name="generic" size={IconSizeClasses.Small} />
      <p className="font-weight-bold text-align-center">
        {t('subscription.needMoreDevicesTitle')}
      </p>
      <p className="text-align-center">{t('subscription.needMoreDevicesText')}</p>
    </div>
  );
}
